export const menu = {
  menu_title: 'Resonance',
  // Header slot actions (ResonanceLayout)
  header_menu_aria: 'Menu',
  header_island_settings_aria: 'Réglages des îles',
  header_call_aria: 'Appeler le {{number}}',
  menu_logOut: 'Déconnexion',
  menu_language_button_text: 'Changer',
  menu_languages_modal_title: 'Langages',
  menu_questionnaires_modal_title: 'Questionnaires',
  menu_share_title: '{{appName}}',
  menu_share_text: 'Découvre {{appName}} 🙂',
  menu_share_link_copied: 'Lien d’invitation {{appName}} copié dans le presse-papiers ✅',
  menu_share_not_supported: 'Le partage n’est pas supporté sur cet appareil.',
  menu_share_link_error: 'Impossible de générer un lien d’invitation pour le moment.',
  menu_share_no_public_link: 'Aucun lien d’invitation public n’est configuré.',
}
